import { readAsData } from '../file';

export const toBlob = (data: BlobPart, type?: string) =>
  new Blob([data], { type });

export const blobToURL = (blob: Blob) => URL.createObjectURL(blob);

export const blobToBase64 = (blob: Blob) => readAsData(blob);
